// extracted by mini-css-extract-plugin
module.exports = {"link":"explore_link__yT84j","more-in":"explore_more-in__2mN_I","tag":"explore_tag__xSsWM","chevronRight":"explore_chevronRight__8XKds"};